<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
   
    <SuperAdmin v-if="userType==2" >
      
          </SuperAdmin>
    <admin-empresa v-if="userType==1 && !userFuncionario" >
    </admin-empresa>
    <PerfilFuncionario v-if="userFuncionario && userType==1">
    </PerfilFuncionario>
    
    <div style="height: 50px;" id="div-with-loading" class="vs-con-loading__container"></div>
  </div>
</template>
  
<script>
import SuperAdmin from './super-admin/SuperAdmin.vue';
import AdminEmpresa from './admin-empresa/AdminEmpresa.vue'
import PerfilFuncionario from '@/views/pages/funcionarioLogado/PerfilFuncionario'
import { PermissionsMixin } from "../../../mixins/permissions";
import Vagas from '@/views/pages/recrutamento/vagas/Vagas'
export default {
  mixins: [PermissionsMixin],
  components: {
    Vagas,
    SuperAdmin,
    AdminEmpresa,
    PerfilFuncionario
  },
  data() {
    return {

     
    }
  },

  mounted() {

    
    
    if(this.userFuncionario && this.userType==1){
           this.$router.push({ name: 'meu-perfil' })
      }

      this.loading()
    },
  


 


  methods: {


    loading(){
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 1.0,
        type:'sound'
      })

     
      setTimeout( ()=> {
      
        this.$vs.loading.close('#div-with-loading > .con-vs-loading')
      }, 2000);
    },
    
  

    //     async increment(){
    //   const userLogado = await this.$store._actions["user/getCurrentUser"][0] 
    //   userLogado()


    //   // const userPermission = this.$store._mutations["user/verifyPermissions"][0] 
    //   // userPermission()


    // },
   
  }
}
</script>
  
<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media(max-width: 576px) {

    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}

/*! rtl:end:ignore */</style>
  